module.exports = __webpack_public_path__ + "static/media/logo.f0d30d6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 664
// module chunks = 0